import React from "react";
import PdfViewer from "../../PdfViewer";

const PolizaUamX2026 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/Poliza-eq-Extreme-UAMX-Feb25-Feb28-NNM.pdf`;
  /*const pdfUrl = "/pdf/Poliza-eq-Extreme-UAMX-Feb25-Feb28-NNM.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Póliza 2026</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PolizaUamX2026;
